import bnbIcon from "@/assets/crypto/bnb.png";
import btcIcon from "@/assets/crypto/btc.png";
import ethIcon from "@/assets/crypto/eth.png";
import solIcon from "@/assets/crypto/sol.png";
import tonIcon from "@/assets/crypto/ton.png";
import trxIcon from "@/assets/crypto/trx.png";
import usdcIcon from "@/assets/crypto/usdc.png";
import usdtIcon from "@/assets/crypto/usdt.png";

const COLOR_MAP = {
  USDT: "#26A17B",
  USDC: "#2775CA",
  TON: "#0098EA",
  SOL: "#9945FF",
  TRX: "#EF0027",
  BTC: "#F7931A",
  ETH: "#627EEA",
  BNB: "#F0B90B",
};

const DEFAULT_COLOR = "#64748B";

const ICON_MAP = {
  usdt: usdtIcon,
  usdc: usdcIcon,
  ton: tonIcon,
  sol: solIcon,
  trx: trxIcon,
  btc: btcIcon,
  eth: ethIcon,
  bnb: bnbIcon,
};

const makeSvgDataUri = (symbol, color) => {
  const text = String(symbol || "?").slice(0, 4).toUpperCase();
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80">
      <defs>
        <linearGradient id="g" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="${color}" stop-opacity="0.95"/>
          <stop offset="100%" stop-color="${color}" stop-opacity="0.75"/>
        </linearGradient>
      </defs>
      <circle cx="40" cy="40" r="38" fill="url(#g)"/>
      <text x="50%" y="52%" font-family="Arial, sans-serif" font-size="26" fill="#FFFFFF" text-anchor="middle" dominant-baseline="middle" font-weight="700">
        ${text}
      </text>
    </svg>
  `;
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};

export const getCryptoIconUrl = (symbol) => {
  const safe = String(symbol || "").toLowerCase();
  return ICON_MAP[safe] || `/icons/crypto/${safe}.png`;
};

export const getCryptoIconFallback = (symbol) => {
  const key = String(symbol || "").toUpperCase();
  const color = COLOR_MAP[key] || DEFAULT_COLOR;
  return makeSvgDataUri(key, color);
};
